<template>
    <div class="mail-wrapper mail-wrapper-two">

        <div class="auth-req col-sm-12">
            <div class="mail-group">
                <div class="mail-group-header justify-content-between">
                    <h6 class="tx-uppercase tx-semibold mg-b-0">Authorization Request</h6>
                    <div class="dropdown tx-13">

                    </div><!-- dropdown -->
                </div><!-- mail-group-header -->
                <div class="mail-group-body">
                    <label class="mail-group-label">All Requests</label>
                    <div v-if="ft.batchLoading" class="text-center">
                        <span  class="spinner-border spinner-border text-danger" role="status" aria-hidden="true"></span>
                        <p class="text-danger">Loading</p>
                    </div>
                    <batch-flash-card v-else :carditems="ft.batches"></batch-flash-card>
                    <div class="pd-t-1 pd-b-5 pd-x-5">
                        <b-button
                                class="btn btn-xs btn-block btn-light bd-0 tx-uppercase tx-10 tx-spacing-1 tx-medium mn-ht-0">
                            Load more
                        </b-button>
                    </div>
                </div><!-- mail-group-body -->
            </div><!-- mail-group -->
        </div>

        <div class="mail-content col-sm-12">
            <div class="mail-content-header">
                <a href="" id="mailContentClose" class="link-02 d-none d-lg-block d-xl-none mg-r-20">
                    <arrow-left-icon></arrow-left-icon>
                </a>
                <div class="media">
                    <div class="avatar avatar-sm"><img src="https://via.placeholder.com/600" class="rounded-circle"
                                                       alt=""></div>
                    <div class="media-body mg-l-10">
                        <h6 class="mg-b-2 tx-13">Authorization Request</h6>
                        <span class="d-block tx-11 tx-color-03">{{ new Date() | moment("hh:mmA, dddd, MMMM Do YYYY") }}</span>
                    </div><!-- media-body -->
                </div>
                <!-- media -->
                <nav class="nav nav-icon-only mg-l-auto">

                </nav>

            </div><!-- mail-content-header -->
            <div class="mail-content-body">
                <div class="tab-content">
                    <div class="d-flex align-items-center justify-content-between p-md-2 mg-b-25">
                        <h6 class="mg-b-0">Account No. {{ ft.batchDetails.account }}</h6>
                        <div class="d-flex" v-if="ft.batchDetails.status === 'pushed'">
                            <b-button v-if="ft.declineloader" disabled
                                      class="btn btn-sm  btn-danger d-flex align-items-center mr-1">
                                <span class="spinner-border spinner-border-sm mr-1" role="status"
                                      aria-hidden="true"></span>
                                Loading...
                            </b-button>
                            <b-button v-else-if="this.auth.response.roles === 'ROLE_AUTHORIZER' || this.auth.response.roles === 'ROLE_VERIFIER'"
                                      :disabled="ft.batchDetails.status === 'declined'"
                                      class="btn btn-sm btn-danger d-flex align-items-center mr-1"
                                      v-b-modal="'confirmdecline'"
                            >
                                <ThumbsDownIcon size="3x" class="wd-10 mg-r-5"/>
                                Decline Batch
                            </b-button>
                            <button v-if="ft.ftLoading" disabled
                                    class="btn btn-sm  btn-outline-success align-items-center mr-1">
                                <span class="spinner-border spinner-border-sm mg-r-5" role="status"
                                      aria-hidden="true"></span>
                                Loading...
                            </button>
                            <b-button v-else-if="this.auth.response.roles === 'ROLE_AUTHORIZER' || this.auth.response.roles === 'ROLE_VERIFIER'"
                                      class="btn btn-sm btn-success d-flex align-items-center mr-1" :disabled="ft.batchDetails.status === 'declined'"
                                      v-b-modal="'confirmpassword'">
                                <ThumbsUpIcon size="3x" class="wd-10 mg-r-5"/>
                                <template v-if="this.auth.response.roles === 'ROLE_AUTHORIZER'">Approve Batch</template>
                                <template v-if="this.auth.response.roles === 'ROLE_VERIFIER'">Verify Batch</template>
                            </b-button>


                        </div>
                    </div>
                    <auth-account-table :fields="fields" :trans="this.ft.singletrans"
                                        :is-busy="this.ft.ftLoading"></auth-account-table>
                    <ConfirmModal  :authorize="authorize" :ft="ft" :hideauth="hideauth"
                                  :password="password"/>
                    <DeclineModal :decline="decline" :ft="ft" :hidedec="hidedec" :password="password"/>

                </div><!-- tab-content -->

            </div><!-- mail-content-body -->
        </div><!-- mail-content -->

    </div>

</template>

<script>

    import {ArrowLeftIcon, ThumbsDownIcon, ThumbsUpIcon} from 'vue-feather-icons'
    import {mapState} from "vuex";
    import BatchFlashCard from "../../components/card/BatchFlashCard";
    import AuthAccountTable from "../../components/table/AuthAccountTable";
    import PerfectScrollbar from "perfect-scrollbar"
    import ConfirmModal from "../../components/modal/ConfirmModal";
    import DeclineModal from "../../components/modal/DeclineModal";

    export default {
        name: 'PaymentAuthRequest',
        components: {
            DeclineModal,
            ConfirmModal,
            AuthAccountTable,
            BatchFlashCard,
            ArrowLeftIcon,
            ThumbsDownIcon,
            ThumbsUpIcon
        },
        data() {
            return {
                fields: [
                    {key: 'creditbankname', label: 'Bank Name', sortable: true, class: 'text-left'},
                    {key: 'creditaccount', label: 'Account No', sortable: true, class: 'text-left'},
                    {key: 'craccountname', label: 'BeneficiaryName', sortable: true, class: 'text-left'},
                    {key: 'amount', label: 'Amount', sortable: true, class: 'text-left'},
                    {key: 'nename', label: 'Validation Name', sortable: true, class: 'text-left'},
                    {key: 'status', label: 'Transfer Status', sortable: true, class: 'text-left'},
                ],
                disabled: false,
            }
        },
        methods: {
            async readBatches() {
                const payload = {customerid: this.auth.response.customerid, status: 'completed'};
                const res = await this.$store.dispatch("ft/readAllBatches", payload, {root: false});
                //console.log(res);
                if (res.responsecode !== "00"){
                    this.$swal({
                        title: 'Warning',
                        text: res.responsemessage,
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonText: 'Ok'
                    });
                }

            },
            push: async function () {
                let model = {
                    userid: this.auth.response.username,
                    batchid: this.ft.batchDetails.batchid,
                };
                let result = await this.$store.dispatch("ft/queueBatch", model, {root: false});
                const payload = {customerid: this.auth.response.customerid, status: 'completed'};
                await this.$store.dispatch("ft/readAllBatches", payload, {root: false});
                this.$swal({
                    title: result.responsecode === '00' ? 'Success' : 'Warning',
                    text: result.responsemessage,
                    icon: result.responsecode === '00' ? 'success' : 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'Ok'
                });
            },
        },
        mounted() {
            const psSidebar = new PerfectScrollbar('.auth-req', {
                suppressScrollX: true
            });
            psSidebar.isAlive = true
        },
        computed: {
            ...mapState(['customer','ft','auth'])
        }
    }


</script>

<style>


    .ps {
        height: 100%;
    }

    .ps__rail-y {
        width: 3px;
        background-color: rgba(72, 83, 114, 0.06);
        z-index: 10;
        position: absolute;
        left: auto !important;
        right: 0;
        opacity: 0;
        margin: 1px;
        transition: opacity 0.2s;
    }


</style>
